var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.listLoaded)?_c('div',[(!_vm.featureCatalogAvailable)?_c('ConstructorInternationalPage'):(!_vm.listActive)?_c('ConstructorInitialPage'):_c('ConstructorPage')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }